import SvgIcon, {SvgIconProps} from '@mui/material/SvgIcon';

export function DoorAccessIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <path
        d="M12 2C13.1 2 14 2.9 14 4V6H16C17.1 6 18 6.9 18 8V20C18 21.1 17.1 22 16 22H8C6.9 22 6 21.1 6 20V8C6 6.9 6.9 6 8 6H10V4C10 2.9 10.9 2 12 2M12 4C11.45 4 11 4.45 11 5V6H13V5C13 4.45 12.55 4 12 4M8 8V20H16V8H8M10 10H14V12H10V10M10 14H14V16H10V14Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
}

export function IntercomCallIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <path
        d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"
        fill="currentColor"
      />
    </SvgIcon>
  );
}

export function ActivityIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <path
        d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
        fill="currentColor"
      />
    </SvgIcon>
  );
}
